import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";

export async function getProfilePictureURL(uid: string): Promise<string> {
    const profileRef = ref(storage, `Profiles/${uid}`);
    

    return await getDownloadURL(profileRef).catch((error) => {
        if (error.code === '404') {
            return `${process.env.PUBLIC_URL}/anonymousUser.png`;
        }
        if (error.code === 'storage/object-not-found') {
            return `${process.env.PUBLIC_URL}/anonymousUser.png`;
        } else {
            return `${process.env.PUBLIC_URL}/anonymousUser.png`;
        }
    });
}

export async function uploadProfilePicture(uid: string, file: File): Promise<void> {
    const profileRef = ref(storage, `Profiles/${uid}`);
    const metadata = {
        contentType: 'image/.*'
    };

    await uploadBytes(profileRef, file, metadata);
}